function localizedShopifyHref(path) {
  const root = window.Shopify?.routes?.root || "/";
  if (root === "/" || String(path).startsWith(root)) return path;
  return `${root}${String(path).replace(/^\/+/, "")}`;
}

(() => {
// Chrisbella page runtime v20260720-commerce.
function createHeaderIcon(label, iconMarkup) {
  const button = document.createElement("button");
  button.className = "page-icon-button";
  button.type = "button";
  button.setAttribute("aria-label", label);
  button.innerHTML = iconMarkup;
  return button;
}

const MEMBERSHIP_SESSION_KEY = "chrisbella-membership-otp";
const MEMBERSHIP_PROFILE_KEY = "chrisbella-membership-profile";
const MEMBERSHIP_OTP_TTL_MS = 5 * 60 * 1000;
const MEMBERSHIP_RESEND_MS = 60 * 1000;

const membershipMessages = {
  en: {
    invalidName: "Enter your full name.",
    invalidPhone: "Enter a valid mobile number for the selected country.",
    invalidDial: "Enter a valid dial code (1–4 digits).",
    acceptTerms: "Please accept the membership terms.",
    codeSent: "Verification code sent on WhatsApp.",
    codeHint: "Preview mode code: {code}. Connect WhatsApp Business API for real delivery.",
    codeSentLive: "Code sent on WhatsApp. Open WhatsApp and enter it here.",
    enterCode: "Enter the 6-digit WhatsApp code.",
    invalidCode: "That code is incorrect. Try again.",
    expiredCode: "This code has expired. Please request a new one.",
    tooManyAttempts: "Too many attempts. Request a new code.",
    verified: "WhatsApp verified. Membership registered on this device.",
    waitResend: "You can resend in {seconds}s.",
    resendReady: "You can resend the WhatsApp code now.",
    sending: "Sending WhatsApp code…",
    verifying: "Verifying…",
    sendFailed: "Could not send the WhatsApp code. Please try again.",
    verifyFailed: "Could not verify the code. Please try again.",
    endpointMissing: "WhatsApp login is not connected yet. Set the OTP API endpoint in theme settings.",
  },
  fr: {
    invalidName: "Saisissez votre nom complet.",
    invalidPhone: "Saisissez un numéro mobile valide pour le pays sélectionné.",
    invalidDial: "Saisissez un indicatif valide (1 à 4 chiffres).",
    acceptTerms: "Veuillez accepter les conditions d'adhésion.",
    codeSent: "Code envoyé sur WhatsApp.",
    codeHint: "Code aperçu : {code}. Connectez l’API WhatsApp Business pour l’envoi réel.",
    codeSentLive: "Code envoyé sur WhatsApp. Ouvrez WhatsApp et saisissez-le ici.",
    enterCode: "Saisissez le code WhatsApp à 6 chiffres.",
    invalidCode: "Code incorrect. Réessayez.",
    expiredCode: "Ce code a expiré. Demandez-en un nouveau.",
    tooManyAttempts: "Trop de tentatives. Demandez un nouveau code.",
    verified: "WhatsApp vérifié. Adhésion enregistrée sur cet appareil.",
    waitResend: "Vous pourrez renvoyer dans {seconds}s.",
    resendReady: "Vous pouvez renvoyer le code WhatsApp.",
    sending: "Envoi du code WhatsApp…",
    verifying: "Vérification…",
    sendFailed: "Envoi WhatsApp impossible. Réessayez.",
    verifyFailed: "Vérification impossible. Réessayez.",
    endpointMissing: "La connexion WhatsApp n'est pas encore configurée.",
  },
  ar: {
    invalidName: "أدخل اسمك الكامل.",
    invalidPhone: "أدخل رقم هاتف صالحاً للدولة المحددة.",
    invalidDial: "أدخل رمز اتصال صالحاً (من 1 إلى 4 أرقام).",
    acceptTerms: "يرجى الموافقة على شروط العضوية.",
    codeSent: "تم إرسال رمز التحقق عبر واتساب.",
    codeHint: "رمز المعاينة: {code}. اربط واتساب بزنس للإرسال الحقيقي.",
    codeSentLive: "تم إرسال الرمز عبر واتساب. افتح واتساب وأدخله هنا.",
    enterCode: "أدخل رمز واتساب المكوّن من 6 أرقام.",
    invalidCode: "الرمز غير صحيح. حاول مرة أخرى.",
    expiredCode: "انتهت صلاحية الرمز. اطلب رمزاً جديداً.",
    tooManyAttempts: "محاولات كثيرة جداً. اطلب رمزاً جديداً.",
    verified: "تم التحقق عبر واتساب. تم تسجيل العضوية على هذا الجهاز.",
    waitResend: "يمكنك إعادة الإرسال خلال {seconds}ث.",
    resendReady: "يمكنك إعادة إرسال رمز واتساب الآن.",
    sending: "جارٍ إرسال رمز واتساب…",
    verifying: "جارٍ التحقق…",
    sendFailed: "تعذر إرسال رمز واتساب. حاول مرة أخرى.",
    verifyFailed: "تعذر التحقق من الرمز. حاول مرة أخرى.",
    endpointMissing: "تسجيل الدخول عبر واتساب غير متصل بعد.",
  },
  zh: {
    invalidName: "请填写姓名。",
    invalidPhone: "请输入所选国家/地区的有效手机号。",
    invalidDial: "请输入有效区号（1–4 位数字）。",
    acceptTerms: "请先同意会员条款。",
    codeSent: "验证码已通过 WhatsApp 发送。",
    codeHint: "预览模式验证码：{code}。接入 WhatsApp Business API 后将真实发送到 WhatsApp。",
    codeSentLive: "验证码已发到 WhatsApp，请打开 WhatsApp 查看并回填。",
    enterCode: "请输入 WhatsApp 收到的 6 位验证码。",
    invalidCode: "验证码不正确，请重试。",
    expiredCode: "验证码已过期，请重新获取。",
    tooManyAttempts: "尝试次数过多，请重新获取验证码。",
    verified: "WhatsApp 验证成功，本设备已完成注册。",
    waitResend: "{seconds} 秒后可重新发送。",
    resendReady: "可以重新发送 WhatsApp 验证码了。",
    sending: "正在发送 WhatsApp 验证码…",
    verifying: "正在验证…",
    sendFailed: "WhatsApp 验证码发送失败，请重试。",
    verifyFailed: "验证失败，请重试。",
    endpointMissing: "尚未接入 WhatsApp 登录接口，请先在主题设置里配置 OTP API。",
  },
};

function membershipLanguage() {
  const locale = document.documentElement.lang || "en";
  if (locale.startsWith("fr")) return "fr";
  if (locale.startsWith("ar")) return "ar";
  if (locale.startsWith("zh")) return "zh";
  return "en";
}

function membershipCopy(key, vars = {}) {
  let text = membershipMessages[membershipLanguage()][key] || membershipMessages.en[key] || key;
  Object.entries(vars).forEach(([name, value]) => {
    text = text.replaceAll(`{${name}}`, String(value));
  });
  return text;
}

const MEMBERSHIP_DIAL_RULES = {
  213: { pattern: /^[567]\d{8}$/, maxLength: 9, placeholder: "5 00 00 00 00" },
  86: { pattern: /^1[3-9]\d{9}$/, maxLength: 11, placeholder: "138 0013 8000" },
  33: { pattern: /^[67]\d{8}$/, maxLength: 9, placeholder: "6 12 34 56 78" },
  212: { pattern: /^[67]\d{8}$/, maxLength: 9, placeholder: "6 12 34 56 78" },
  216: { pattern: /^[2459]\d{7}$/, maxLength: 8, placeholder: "20 123 456" },
};

const MEMBERSHIP_DEFAULT_COUNTRIES_TEXT = [
  "DZ|213|Algeria|555123456",
  "CN|86|China|13800138000",
  "FR|33|France|612345678",
  "MA|212|Morocco|612345678",
  "TN|216|Tunisia|20123456",
].join("\n");

function parseMembershipCountries(text) {
  const lines = String(text || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
  const countries = [];
  for (const line of lines) {
    const [iso, dial, label, example = ""] = line.split("|").map((part) => part.trim());
    const dialDigits = String(dial || "").replace(/\D/g, "");
    if (!iso || !dialDigits || !label) continue;
    countries.push({
      iso: iso.toUpperCase(),
      dial: dialDigits,
      label,
      example: String(example || "").replace(/\D/g, ""),
    });
  }
  return countries;
}

function getMembershipConfig() {
  const raw = window.CB_MEMBERSHIP_CONFIG || {};
  const countries = parseMembershipCountries(raw.countriesText || MEMBERSHIP_DEFAULT_COUNTRIES_TEXT);
  const fallback = countries[0] || { iso: "DZ", dial: "213", label: "Algeria", example: "555123456" };
  const defaultIso = String(raw.defaultCountry || fallback.iso).toUpperCase();
  const defaultCountry = countries.find((item) => item.iso === defaultIso) || fallback;
  const otpMode = String(raw.otpMode || "preview").toLowerCase() === "live" ? "live" : "preview";
  const otpEndpoint = String(raw.otpEndpoint || "").trim().replace(/\/$/, "");
  return {
    countries: countries.length ? countries : [fallback],
    defaultCountry,
    allowManualDial: raw.allowManualDial !== false,
    otpMode,
    otpEndpoint,
  };
}

function formatMembershipDisplay(dial, local) {
  if (dial === "86" && local.length === 11) {
    return `+86 ${local.slice(0, 3)} ${local.slice(3, 7)} ${local.slice(7)}`;
  }
  if (dial === "213" && local.length === 9) {
    return `+213 ${local.slice(0, 3)} ${local.slice(3, 5)} ${local.slice(5, 7)} ${local.slice(7)}`;
  }
  return `+${dial} ${local}`;
}

function normalizeMembershipMobile(rawLocal, rawDial) {
  const dial = String(rawDial || "").replace(/\D/g, "");
  if (!/^\d{1,4}$/.test(dial)) return null;

  let digits = String(rawLocal || "").replace(/\D/g, "");
  if (digits.startsWith(dial)) digits = digits.slice(dial.length);
  if (digits.startsWith("0")) digits = digits.slice(1);

  const rule = MEMBERSHIP_DIAL_RULES[dial];
  if (rule) {
    if (!rule.pattern.test(digits)) return null;
  } else if (!/^\d{6,15}$/.test(digits)) {
    return null;
  }

  return {
    local: digits,
    dial,
    e164: `+${dial}${digits}`,
    display: formatMembershipDisplay(dial, digits),
  };
}

function parseMembershipE164(e164) {
  const value = String(e164 || "");
  const match = value.match(/^\+(\d{1,4})(\d{6,15})$/);
  if (!match) return null;
  return normalizeMembershipMobile(match[2], match[1]);
}

function readMembershipJson(key) {
  try {
    return JSON.parse(sessionStorage.getItem(key) || localStorage.getItem(key) || "null");
  } catch {
    return null;
  }
}

function writeMembershipSession(payload) {
  sessionStorage.setItem(MEMBERSHIP_SESSION_KEY, JSON.stringify(payload));
}

function clearMembershipSession() {
  sessionStorage.removeItem(MEMBERSHIP_SESSION_KEY);
}

function writeMembershipProfile(profile) {
  localStorage.setItem(MEMBERSHIP_PROFILE_KEY, JSON.stringify(profile));
}

function clearMembershipProfile() {
  localStorage.removeItem(MEMBERSHIP_PROFILE_KEY);
}

function createMembershipOtp() {
  return String(Math.floor(100000 + Math.random() * 900000));
}

function membershipCountryLabel(country) {
  return `${country.label} (+${country.dial})`;
}

function buildMembershipCountryPicker(config) {
  const wrap = document.createElement("div");
  wrap.className = "membership-country-field";
  wrap.innerHTML = `
    <span>Country <b aria-hidden="true">*</b></span>
    <div class="membership-country-picker" data-membership-country-picker>
      <input type="hidden" name="membership_country" value="${config.defaultCountry.iso}" data-membership-country />
      <button type="button" class="membership-country-trigger" data-membership-country-trigger aria-haspopup="listbox" aria-expanded="false">
        <span data-membership-country-label>${membershipCountryLabel(config.defaultCountry)}</span>
        <span class="membership-country-caret" aria-hidden="true"></span>
      </button>
      <ul class="membership-country-menu" data-membership-country-menu hidden role="listbox"></ul>
    </div>
  `;
  const menu = wrap.querySelector("[data-membership-country-menu]");
  for (const country of config.countries) {
    const item = document.createElement("li");
    item.setAttribute("role", "option");
    item.tabIndex = -1;
    item.dataset.iso = country.iso;
    item.dataset.dial = country.dial;
    item.dataset.example = country.example || "";
    item.textContent = membershipCountryLabel(country);
    if (country.iso === config.defaultCountry.iso) item.setAttribute("aria-selected", "true");
    menu.appendChild(item);
  }
  if (config.allowManualDial) {
    const custom = document.createElement("li");
    custom.setAttribute("role", "option");
    custom.tabIndex = -1;
    custom.dataset.iso = "__custom__";
    custom.dataset.dial = "";
    custom.textContent = "Other / custom dial code";
    menu.appendChild(custom);
  }
  return wrap;
}

function ensureMembershipOtpMarkup() {
  const panel = document.querySelector(".membership-panel");
  if (!panel) return false;
  let shell = document.querySelector("[data-membership-shell]");
  if (!shell) {
    const legacyForm = document.querySelector("[data-membership-form], .membership-form");
    if (!legacyForm) return false;
    shell = document.createElement("div");
    shell.className = "membership-form-shell";
    shell.setAttribute("data-membership-shell", "");
    shell.innerHTML = `
      <form class="membership-form" data-membership-step="phone" action="#" method="post" novalidate>
        <p class="membership-step-label">Step 1 of 2 · Mobile number</p>
        <label>
          <span>Full name <b aria-hidden="true">*</b></span>
          <input type="text" name="membership_name" autocomplete="name" required />
        </label>
        <div data-membership-country-slot></div>
        <label>
          <span>Mobile number <b aria-hidden="true">*</b></span>
          <div class="membership-phone-row">
            <input type="tel" name="membership_dial" class="membership-dial-input" inputmode="numeric" maxlength="4" value="+213" placeholder="+213" aria-label="Country dial code" data-membership-dial required />
            <input type="tel" name="membership_phone_local" autocomplete="tel-national" inputmode="numeric" maxlength="15" placeholder="5 00 00 00 00" aria-label="Mobile number without country code" data-membership-phone-local required />
          </div>
          <span class="membership-field-hint" data-membership-phone-hint>Dial code follows the selected country.</span>
        </label>
        <label class="membership-consent">
          <input type="checkbox" name="membership_terms" required />
          <span>I agree that Chrisbella may message this WhatsApp number to verify and manage my membership.</span>
        </label>
        <button type="button" data-membership-send>Send WhatsApp code</button>
        <p class="membership-form-message" data-membership-status role="status" aria-live="polite"></p>
      </form>
      <form class="membership-form" data-membership-step="otp" action="#" method="post" hidden novalidate>
        <p class="membership-step-label">Step 2 of 2 · Verification code</p>
        <p class="membership-otp-target">WhatsApp code sent to <strong data-membership-phone-display></strong></p>
        <label>
          <span>WhatsApp code <b aria-hidden="true">*</b></span>
          <input type="text" name="membership_otp" inputmode="numeric" autocomplete="one-time-code" maxlength="6" pattern="[0-9]{6}" placeholder="••••••" required />
        </label>
        <button type="button" data-membership-verify>Verify and register</button>
        <div class="membership-otp-actions">
          <button type="button" class="membership-text-button" data-membership-resend>Resend WhatsApp code</button>
          <button type="button" class="membership-text-button" data-membership-edit-phone>Change number</button>
        </div>
        <p class="membership-form-note" data-membership-countdown></p>
        <p class="membership-form-message" data-membership-status role="status" aria-live="polite"></p>
      </form>
      <div class="membership-success" data-membership-step="success" hidden>
        <p class="membership-step-label">Welcome</p>
        <h2>You’re in, <span data-membership-success-name></span>.</h2>
        <p>Your member identity is <strong data-membership-success-phone></strong>.</p>
        <a class="membership-success-cta" href="/">Continue shopping</a>
        <button type="button" class="membership-text-button" data-membership-signout>Sign out on this device</button>
      </div>
    `;
    legacyForm.replaceWith(shell);
  }

  const config = getMembershipConfig();
  const phoneStep = shell.querySelector('[data-membership-step="phone"]');
  const existingPicker = shell.querySelector("[data-membership-country-picker]");
  const legacyCountryLabel =
    shell.querySelector(".membership-country-field") ||
    shell.querySelector("[name='membership_country']")?.closest("label");
  const slot = shell.querySelector("[data-membership-country-slot]");

  if (!existingPicker) {
    const picker = buildMembershipCountryPicker(config);
    if (slot) slot.replaceWith(picker);
    else if (legacyCountryLabel) legacyCountryLabel.replaceWith(picker);
    else if (phoneStep) {
      const phoneLabel = phoneStep.querySelector(".membership-phone-row")?.closest("label");
      if (phoneLabel) phoneStep.insertBefore(picker, phoneLabel);
    }
  }

  const dialInput = shell.querySelector("[data-membership-dial], [name='membership_dial']");
  if (dialInput && !dialInput.value) dialInput.value = `+${config.defaultCountry.dial}`;

  const intro = panel.querySelector("#membership-title")?.nextElementSibling;
  if (intro && intro.tagName === "P") {
    intro.textContent = "Choose your country and WhatsApp number. We’ll send a one-time code on WhatsApp to finish registration.";
  }
  return true;
}

async function membershipOtpRequest(path, payload, config) {
  if (!config.otpEndpoint) {
    const error = new Error("endpoint_missing");
    error.code = "endpoint_missing";
    throw error;
  }
  const headers = { "Content-Type": "application/json", Accept: "application/json" };
  const response = await fetch(`${config.otpEndpoint}${path}`, {
    method: "POST",
    headers,
    body: JSON.stringify(payload),
  });
  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }
  if (!response.ok) {
    const error = new Error(data?.message || "request_failed");
    error.code = data?.code || "request_failed";
    error.status = response.status;
    throw error;
  }
  return data || {};
}

function setupMembershipOtp() {
  if (!ensureMembershipOtpMarkup()) return;
  const shell = document.querySelector("[data-membership-shell]");
  if (!shell || shell.dataset.membershipReady === "1") return;
  shell.dataset.membershipReady = "1";

  const config = getMembershipConfig();
  const phoneForm = shell.querySelector('[data-membership-step="phone"]');
  const otpForm = shell.querySelector('[data-membership-step="otp"]');
  const successPanel = shell.querySelector('[data-membership-step="success"]');
  const phoneInput = shell.querySelector("[data-membership-phone-local], [name='membership_phone_local']");
  const dialInput = shell.querySelector("[data-membership-dial], [name='membership_dial']");
  const countryInput = shell.querySelector("[data-membership-country], [name='membership_country']");
  const countryTrigger = shell.querySelector("[data-membership-country-trigger]");
  const countryLabel = shell.querySelector("[data-membership-country-label]");
  const countryMenu = shell.querySelector("[data-membership-country-menu]");
  const nameInput = phoneForm?.elements?.namedItem("membership_name");
  const termsInput = phoneForm?.elements?.namedItem("membership_terms");
  const otpInput = otpForm?.elements?.namedItem("membership_otp");
  const phoneHint = shell.querySelector("[data-membership-phone-hint]");
  const phoneDisplay = shell.querySelector("[data-membership-phone-display]");
  const successName = shell.querySelector("[data-membership-success-name]");
  const successPhone = shell.querySelector("[data-membership-success-phone]");
  const countdown = shell.querySelector("[data-membership-countdown]");
  const resendButton = shell.querySelector("[data-membership-resend]");
  const editPhoneButton = shell.querySelector("[data-membership-edit-phone]");
  const signOutButton = shell.querySelector("[data-membership-signout]");
  const sendButton = shell.querySelector("[data-membership-send]");
  const verifyButton = shell.querySelector("[data-membership-verify]");

  let countdownTimer = null;
  let menuOpen = false;

  function statusFor(stepEl, text, isError = true) {
    const status = stepEl?.querySelector("[data-membership-status]");
    if (!status) return;
    status.textContent = text || "";
    status.classList.toggle("is-success", Boolean(text) && !isError);
  }

  function showStep(step) {
    [phoneForm, otpForm, successPanel].forEach((panel) => {
      if (!panel) return;
      panel.hidden = panel.getAttribute("data-membership-step") !== step;
    });
  }

  function stopCountdown() {
    if (countdownTimer) {
      window.clearInterval(countdownTimer);
      countdownTimer = null;
    }
  }

  function startCountdown(sentAt) {
    stopCountdown();
    const tick = () => {
      const remain = Math.max(0, Math.ceil((sentAt + MEMBERSHIP_RESEND_MS - Date.now()) / 1000));
      if (countdown) {
        countdown.textContent = remain > 0 ? membershipCopy("waitResend", { seconds: remain }) : membershipCopy("resendReady");
      }
      if (resendButton) resendButton.disabled = remain > 0;
      if (remain <= 0) stopCountdown();
    };
    tick();
    countdownTimer = window.setInterval(tick, 1000);
  }

  function closeCountryMenu() {
    menuOpen = false;
    if (countryMenu) countryMenu.hidden = true;
    if (countryTrigger) countryTrigger.setAttribute("aria-expanded", "false");
  }

  function openCountryMenu() {
    menuOpen = true;
    if (countryMenu) countryMenu.hidden = false;
    if (countryTrigger) countryTrigger.setAttribute("aria-expanded", "true");
  }

  function applyCountry(country, { fillDial = true } = {}) {
    if (!country) return;
    if (countryInput) countryInput.value = country.iso;
    if (countryLabel) countryLabel.textContent = country.iso === "__custom__" ? "Other / custom dial code" : membershipCountryLabel(country);
    countryMenu?.querySelectorAll('[role="option"]').forEach((item) => {
      item.setAttribute("aria-selected", item.dataset.iso === country.iso ? "true" : "false");
    });
    if (fillDial && dialInput && country.dial) {
      dialInput.value = `+${country.dial}`;
    }
    if (dialInput) {
      dialInput.readOnly = !config.allowManualDial && country.iso !== "__custom__" && Boolean(country.dial);
    }
    const dial = String(country.dial || dialInput?.value || "").replace(/\D/g, "");
    const rule = MEMBERSHIP_DIAL_RULES[dial];
    if (phoneInput) {
      phoneInput.maxLength = rule?.maxLength || 15;
      phoneInput.placeholder = rule?.placeholder || "Mobile number";
    }
    if (phoneHint) {
      if (country.iso === "__custom__") {
        phoneHint.textContent = "Type any dial code, then your local mobile number.";
      } else if (country.example) {
        phoneHint.textContent = `${country.label} example: ${country.example}`;
      } else {
        phoneHint.textContent = `Dial code +${dial} follows the selected country.`;
      }
    }
  }

  function countryFromIso(iso) {
    if (iso === "__custom__") return { iso: "__custom__", dial: "", label: "Other", example: "" };
    return (
      config.countries.find((item) => item.iso === iso) ||
      config.defaultCountry
    );
  }

  function syncCountryFromDial() {
    const dial = String(dialInput?.value || "").replace(/\D/g, "");
    const match = config.countries.find((item) => item.dial === dial);
    if (match) applyCountry(match, { fillDial: false });
    else if (config.allowManualDial) applyCountry({ iso: "__custom__", dial: "", label: "Other", example: "" }, { fillDial: false });
  }

  countryTrigger?.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (menuOpen) closeCountryMenu();
    else openCountryMenu();
  });

  countryMenu?.addEventListener("click", (event) => {
    const option = event.target.closest('[role="option"]');
    if (!option) return;
    event.preventDefault();
    event.stopPropagation();
    const country = {
      iso: option.dataset.iso,
      dial: String(option.dataset.dial || "").replace(/\D/g, ""),
      label: String(option.textContent || "").replace(/\s*\(\+\d+\)\s*$/, "").trim(),
      example: String(option.dataset.example || "").replace(/\D/g, ""),
    };
    applyCountry(country, { fillDial: true });
    closeCountryMenu();
    phoneInput?.focus();
  });

  document.addEventListener("click", (event) => {
    if (!menuOpen) return;
    if (event.target.closest("[data-membership-country-picker]")) return;
    closeCountryMenu();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeCountryMenu();
  });

  applyCountry(countryFromIso(countryInput?.value || config.defaultCountry.iso), { fillDial: true });

  async function issueCode({ name, phone }, { announce = true } = {}) {
    const sentAt = Date.now();
    let previewCode = "";

    if (config.otpMode === "live") {
      try {
        await membershipOtpRequest(
          "/otp/send",
          { phone: phone.e164, name, locale: membershipLanguage() },
          config,
        );
      } catch (error) {
        if (error.code === "endpoint_missing") {
          statusFor(phoneForm, membershipCopy("endpointMissing"));
        } else {
          statusFor(phoneForm, membershipCopy("sendFailed"));
        }
        return null;
      }
    } else {
      previewCode = createMembershipOtp();
    }

    writeMembershipSession({
      name,
      phone: phone.e164,
      phoneDisplay: phone.display,
      code: previewCode || null,
      mode: config.otpMode,
      sentAt,
      expiresAt: sentAt + MEMBERSHIP_OTP_TTL_MS,
      attempts: 0,
    });
    if (phoneDisplay) phoneDisplay.textContent = phone.display;
    if (otpInput) otpInput.value = "";
    showStep("otp");
    startCountdown(sentAt);
    if (announce) {
      if (config.otpMode === "live") {
        statusFor(otpForm, membershipCopy("codeSentLive"), false);
      } else {
        statusFor(otpForm, `${membershipCopy("codeSent")} ${membershipCopy("codeHint", { code: previewCode })}`, false);
      }
    }
    otpInput?.focus();
    return previewCode;
  }

  function showSuccess(profile) {
    stopCountdown();
    clearMembershipSession();
    if (successName) successName.textContent = profile.name;
    if (successPhone) successPhone.textContent = profile.phoneDisplay || profile.phone;
    showStep("success");
  }

  const existingProfile = readMembershipJson(MEMBERSHIP_PROFILE_KEY);
  if (existingProfile?.phone && existingProfile?.name) {
    showSuccess(existingProfile);
  }

  phoneInput?.addEventListener("input", () => {
    phoneInput.value = phoneInput.value.replace(/[^\d\s]/g, "");
    phoneInput.setCustomValidity("");
  });

  dialInput?.addEventListener("input", () => {
    const digits = String(dialInput.value || "").replace(/\D/g, "").slice(0, 4);
    dialInput.value = digits ? `+${digits}` : "";
    dialInput.setCustomValidity("");
    syncCountryFromDial();
  });

  otpInput?.addEventListener("input", () => {
    otpInput.value = otpInput.value.replace(/\D/g, "").slice(0, 6);
    otpInput.setCustomValidity("");
  });

  async function handleSendCode(event) {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    statusFor(phoneForm, "");
    closeCountryMenu();

    const name = String(nameInput?.value || "").trim();
    if (name.length < 2) {
      nameInput?.setCustomValidity(membershipCopy("invalidName"));
      nameInput?.reportValidity();
      return;
    }
    nameInput?.setCustomValidity("");

    const dial = String(dialInput?.value || "").replace(/\D/g, "");
    if (!/^\d{1,4}$/.test(dial)) {
      dialInput?.setCustomValidity(membershipCopy("invalidDial"));
      dialInput?.reportValidity();
      return;
    }
    dialInput?.setCustomValidity("");

    const phone = normalizeMembershipMobile(phoneInput?.value, dial);
    if (!phone) {
      phoneInput?.setCustomValidity(membershipCopy("invalidPhone"));
      phoneInput?.reportValidity();
      return;
    }
    phoneInput?.setCustomValidity("");

    if (!termsInput?.checked) {
      termsInput?.setCustomValidity(membershipCopy("acceptTerms"));
      termsInput?.reportValidity();
      return;
    }
    termsInput?.setCustomValidity("");

    if (sendButton) sendButton.disabled = true;
    statusFor(phoneForm, membershipCopy("sending"), false);
    try {
      await issueCode({ name, phone });
    } finally {
      if (sendButton) sendButton.disabled = false;
    }
  }

  async function handleVerifyCode(event) {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    const session = readMembershipJson(MEMBERSHIP_SESSION_KEY);
    if (!session?.phone) {
      statusFor(otpForm, membershipCopy("expiredCode"));
      showStep("phone");
      return;
    }

    if (Date.now() > Number(session.expiresAt || 0)) {
      clearMembershipSession();
      statusFor(otpForm, membershipCopy("expiredCode"));
      return;
    }

    const code = String(otpInput?.value || "").trim();
    if (!/^\d{6}$/.test(code)) {
      otpInput?.setCustomValidity(membershipCopy("enterCode"));
      otpInput?.reportValidity();
      return;
    }
    otpInput?.setCustomValidity("");

    if (session.attempts >= 5) {
      statusFor(otpForm, membershipCopy("tooManyAttempts"));
      return;
    }

    if (verifyButton) verifyButton.disabled = true;
    statusFor(otpForm, membershipCopy("verifying"), false);

    try {
      if (session.mode === "live" || config.otpMode === "live") {
        await membershipOtpRequest(
          "/otp/verify",
          { phone: session.phone, code, name: session.name },
          config,
        );
      } else if (code !== String(session.code)) {
        session.attempts = Number(session.attempts || 0) + 1;
        writeMembershipSession(session);
        statusFor(otpForm, membershipCopy("invalidCode"));
        return;
      }

      const profile = {
        name: session.name,
        phone: session.phone,
        phoneDisplay: session.phoneDisplay,
        verifiedAt: new Date().toISOString(),
      };
      writeMembershipProfile(profile);
      statusFor(otpForm, membershipCopy("verified"), false);
      showSuccess(profile);
    } catch {
      session.attempts = Number(session.attempts || 0) + 1;
      writeMembershipSession(session);
      statusFor(otpForm, membershipCopy("verifyFailed"));
    } finally {
      if (verifyButton) verifyButton.disabled = false;
    }
  }

  phoneForm?.addEventListener("submit", handleSendCode);
  otpForm?.addEventListener("submit", handleVerifyCode);
  sendButton?.addEventListener("click", handleSendCode);
  verifyButton?.addEventListener("click", handleVerifyCode);

  resendButton?.addEventListener("click", async () => {
    const session = readMembershipJson(MEMBERSHIP_SESSION_KEY);
    if (!session?.phone || !session?.name) {
      showStep("phone");
      return;
    }
    if (Date.now() < Number(session.sentAt || 0) + MEMBERSHIP_RESEND_MS) return;
    const phone = parseMembershipE164(session.phone);
    if (!phone) {
      showStep("phone");
      return;
    }
    await issueCode({ name: session.name, phone });
  });

  editPhoneButton?.addEventListener("click", () => {
    stopCountdown();
    clearMembershipSession();
    showStep("phone");
    statusFor(phoneForm, "");
    phoneInput?.focus();
  });

  signOutButton?.addEventListener("click", () => {
    clearMembershipProfile();
    clearMembershipSession();
    showStep("phone");
    if (phoneForm) phoneForm.reset();
    applyCountry(config.defaultCountry, { fillDial: true });
    statusFor(phoneForm, "");
  });

  termsInput?.addEventListener("change", () => {
    termsInput.setCustomValidity("");
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setupMembershipOtp, { once: true });
} else {
  setupMembershipOtp();
}

const LANGUAGE_STORAGE_KEY = "chrisbella-algeria-locale";
const DEFAULT_LANGUAGE = "fr";

const supportedLanguages = ["fr", "ar", "en"];
const languageMeta = {
  fr: { htmlLang: "fr", dir: "ltr", label: "FR" },
  ar: { htmlLang: "ar", dir: "rtl", label: "العربية" },
  en: { htmlLang: "en", dir: "ltr", label: "EN" },
};
const pageClientLocaleFiles = {
  en: "client-ui.en.default.json",
  fr: "client-ui.fr.json",
  ar: "client-ui.ar.json",
};
const pageClientLocaleBaseUrl = new URL(
  "../shopify-locales/",
  document.currentScript?.src || new URL("pages/page.js", window.location.href),
);
const pagePreviewTranslationCache = new Map();

function hasNativeShopifyTranslations() {
  return Boolean(
    window.CB_NATIVE_TRANSLATIONS &&
    Object.keys(window.CB_NATIVE_TRANSLATIONS).length,
  );
}

async function loadPagePreviewTranslations(language) {
  if (hasNativeShopifyTranslations()) return window.CB_NATIVE_TRANSLATIONS;
  if (language === "en") return {};
  if (!pagePreviewTranslationCache.has(language)) {
    pagePreviewTranslationCache.set(language, (async () => {
      const [englishResponse, languageResponse] = await Promise.all([
        fetch(new URL(pageClientLocaleFiles.en, pageClientLocaleBaseUrl)),
        fetch(new URL(pageClientLocaleFiles[language], pageClientLocaleBaseUrl)),
      ]);
      if (!englishResponse.ok || !languageResponse.ok) return {};
      const english = (await englishResponse.json()).client_ui || {};
      const translated = (await languageResponse.json()).client_ui || {};
      return Object.fromEntries(
        Object.entries(english).map(([key, source]) => [source, translated[key] || source]),
      );
    })());
  }
  try {
    return await pagePreviewTranslationCache.get(language);
  } catch {
    return {};
  }
}
let activeLanguage = readStoredLanguage();
const pageTitleSource = document.title;

function normalizeLanguage(value) {
  const locale = String(value || "").trim().toLowerCase().replace("_", "-");
  if (supportedLanguages.includes(locale)) return locale;
  if (locale.startsWith("zh")) return DEFAULT_LANGUAGE;
  if (locale.startsWith("ar")) return "ar";
  if (locale.startsWith("en")) return "en";
  if (locale.startsWith("fr")) return "fr";
  return DEFAULT_LANGUAGE;
}

function readPathLanguage() {
  const localeSegment = window.location.pathname.split("/").filter(Boolean)[0] || "";
  // Shopify serves the stable source copy from /en. The selected UI language
  // remains in shared storage so it survives navigation between theme pages.
  if (!/^(?:fr|ar)(?:[-_][a-z0-9]+)*$/i.test(localeSegment)) return "";
  return normalizeLanguage(localeSegment);
}

function stripLocalePrefix(pathname) {
  return String(pathname || "/")
    .replace(/^\/(en|fr|ar)(?:-[A-Za-z0-9]+)?(?=\/|$)/i, "")
    .replace(/\/{2,}/g, "/") || "/";
}

function englishSourceRoot() {
  const alternate = document.querySelector(
    'link[rel~="alternate"][hreflang="en"], link[rel~="alternate"][hreflang^="en-"]',
  );
  if (alternate?.href) {
    try {
      const alternateUrl = new URL(alternate.href, window.location.origin);
      const firstSegment = alternateUrl.pathname.split("/").filter(Boolean)[0] || "";
      return /^en(?:-[a-z0-9]+)?$/i.test(firstSegment) ? `/${firstSegment}` : "/";
    } catch {
      // Fall back to the theme-provided source root below.
    }
  }

  const configured = String(
    window.CB_I18N_SOURCE_ROOT ||
    document.documentElement.dataset.cbI18nSourceRoot ||
    "/en",
  ).trim();
  if (!configured || configured === "/") return "/";
  return `/${configured.replace(/^\/+|\/+$/g, "")}`;
}

function clientLanguageUrl(language = activeLanguage) {
  const url = new URL(window.location.href);
  const barePath = stripLocalePrefix(url.pathname);
  const sourceRoot = englishSourceRoot();
  url.pathname = sourceRoot === "/"
    ? barePath
    : `${sourceRoot}${barePath === "/" ? "" : barePath}`;
  if (
    hasNativeShopifyTranslations() &&
    barePath === "/" &&
    normalizeLanguage(document.documentElement.lang) !== "en"
  ) {
    url.pathname = "/";
    url.searchParams.set("view", "colors");
  }
  if (language && language !== DEFAULT_LANGUAGE) url.searchParams.set("lang", language);
  else url.searchParams.delete("lang");
  return url;
}

function ensureEnglishSourceForI18n() {
  if (!hasNativeShopifyTranslations()) return false;
  if (normalizeLanguage(document.documentElement.lang) === "en") return false;

  const target = clientLanguageUrl(activeLanguage);
  if (target.href === window.location.href) return false;
  window.location.replace(target.toString());
  return true;
}

function readStoredLanguage() {
  try {
    if (hasNativeShopifyTranslations()) {
      return normalizeLanguage(document.documentElement.lang);
    }
    const params = new URLSearchParams(window.location.search);
    const queryLang = params.get("lang");
    if (queryLang) return normalizeLanguage(queryLang);
    const pathLanguage = readPathLanguage();
    if (pathLanguage) return pathLanguage;
    const storedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (storedLanguage) return normalizeLanguage(storedLanguage);
    return DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
}

function storeLanguage(language) {
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    // Local file preview can run without storage in some browsers.
  }
}

function normalizeText(value) {
  return String(value).replace(/\s+/g, " ").trim();
}

function decodeTranslationText(value) {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = String(value);
  return textarea.value;
}

function translatedText(value) {
  const source = normalizeText(value);
  return decodeTranslationText(window.CB_NATIVE_TRANSLATIONS?.[source] || source);
}

function translateTextNodes(root) {
  if (!root) return;

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (!normalizeText(node.nodeValue)) return NodeFilter.FILTER_REJECT;
      if (node.parentElement?.closest("script, style, [data-language-select]")) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    },
  });

  const textNodes = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode);

  textNodes.forEach((node) => {
    if (!node.__i18nSource) node.__i18nSource = normalizeText(node.nodeValue);
    const leading = node.nodeValue.match(/^\s*/)?.[0] || "";
    const trailing = node.nodeValue.match(/\s*$/)?.[0] || "";
    const translated = translatedText(node.__i18nSource);
    node.nodeValue = `${leading}${translated}${trailing}`;
  });
}

function createLanguageButton() {
  const select = document.createElement("select");
  select.className = "page-lang-select";
  select.dataset.languageSelect = "";
  select.setAttribute("aria-label", "Language");
  select.innerHTML = `
    <option value="fr">FR</option>
    <option value="en">EN</option>
    <option value="ar">العربية</option>
  `;
  return select;
}

function updateLanguageControls() {
  document.querySelectorAll("[data-language-select]").forEach((select) => {
    const matchingOption = [...select.options].find(
      (option) => normalizeLanguage(option.value) === activeLanguage,
    );
    if (matchingOption) select.value = matchingOption.value;
  });
}

function ensureLanguageButton() {
  document.querySelectorAll(".page-actions").forEach((actions) => {
    if (actions.querySelector("[data-language-select]")) return;
    const firstIcon = actions.querySelector(".page-icon-button");
    actions.insertBefore(createLanguageButton(), firstIcon);
  });
}

async function applyLanguageMode() {
  const language = activeLanguage;
  const translations = await loadPagePreviewTranslations(language);
  if (language !== activeLanguage) return;
  if (Object.keys(translations).length) {
    window.CB_NATIVE_TRANSLATIONS = translations;
  }
  const meta = languageMeta[language] || languageMeta.en;
  document.documentElement.lang = meta.htmlLang;
  document.documentElement.dir = meta.dir;
  document.title = translatedText(pageTitleSource);
  translateTextNodes(document.body);
  updateLanguageControls();
}

function setupLanguageMode() {
  if (window.CB_I18N_BOOTSTRAPPED) return;

  ensureLanguageButton();
  document.querySelectorAll("[data-language-select]").forEach((select) => {
    const matchingOption = [...select.options].find(
      (option) => normalizeLanguage(option.value) === activeLanguage,
    );
    if (matchingOption) select.value = matchingOption.value;
    select.addEventListener("change", () => {
      const option = select.selectedOptions[0];
      activeLanguage = normalizeLanguage(option?.dataset.cbLang || select.value);
      storeLanguage(activeLanguage);

      const localizationForm = select.closest("form.localization-form");
      if (
        hasNativeShopifyTranslations() &&
        option?.dataset.cbShopify === "1" &&
        localizationForm
      ) {
        if (typeof localizationForm.requestSubmit === "function") localizationForm.requestSubmit();
        else localizationForm.submit();
        return;
      }

      if (hasNativeShopifyTranslations()) {
        const target = clientLanguageUrl(activeLanguage);
        if (target.href !== window.location.href) {
          window.location.assign(target.toString());
          return;
        }
      }
      applyLanguageMode();
    });
  });

  applyLanguageMode();
}

function setupPageHeader() {
  const header = document.querySelector(".page-header");
  if (!header || header.classList.contains("page-header-full")) return;

  const links = [...header.querySelectorAll("a")];
  const brand = links.find((link) => link.getAttribute("href") === "/");
  const backLink = links.find((link) => link !== brand);

  if (brand) brand.classList.add("page-brand");
  if (backLink) backLink.classList.add("page-back");

  const nav = document.createElement("nav");
  nav.className = "page-nav";
  nav.setAttribute("aria-label", "二级页导航");
  nav.innerHTML = `
    <a href="/#spotlight">Products</a>
    <a href="/#summer">Collections</a>
    <a href="${localizedShopifyHref("/pages/lived-in")}">Lived In</a>
    <a href="/#stores">Brand</a>
  `;

  const actions = document.createElement("div");
  actions.className = "page-actions";
  actions.setAttribute("aria-label", "快捷入口");
  if (backLink) actions.append(backLink);
  actions.append(
    createLanguageButton(),
    createHeaderIcon("搜索", '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.4"></circle><path d="m16 16 4 4"></path></svg>')
  );

  header.append(nav, actions);
}

function setupNewArrivalsPage() {
  const grid = document.querySelector("[data-new-grid]");
  if (!grid) return;

  const products = [...grid.querySelectorAll("[data-new-product]")];
  const filterButtons = [...document.querySelectorAll("[data-new-filter]")];
  const sortSelect = document.querySelector("[data-new-sort]");
  const count = document.querySelector("[data-new-count]");
  const originalOrder = new Map(products.map((product, index) => [product, index]));
  let activeFilter = "all";
  let countValue = null;

  if (count) {
    countValue = document.createElement("span");
    const countLabel = document.createElement("span");
    countLabel.textContent = "products";
    count.setAttribute("aria-live", "polite");
    count.replaceChildren(countValue, document.createTextNode(" "), countLabel);
  }

  const applyProductView = () => {
    const sortMode = sortSelect?.value || "featured";
    const collator = new Intl.Collator(languageMeta[activeLanguage]?.htmlLang || "en", {
      sensitivity: "base",
    });
    const sortedProducts = [...products].sort((first, second) => {
      if (sortMode === "price-asc") {
        return Number(first.dataset.price || 0) - Number(second.dataset.price || 0);
      }
      if (sortMode === "price-desc") {
        return Number(second.dataset.price || 0) - Number(first.dataset.price || 0);
      }
      if (sortMode === "name") {
        return collator.compare(first.dataset.name || "", second.dataset.name || "");
      }
      return originalOrder.get(first) - originalOrder.get(second);
    });

    sortedProducts.forEach((product) => grid.append(product));

    let visibleCount = 0;
    products.forEach((product) => {
      const isVisible = activeFilter === "all" || product.dataset.category === activeFilter;
      product.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    if (countValue) countValue.textContent = String(visibleCount);
  };

  filterButtons.forEach((button) => {
    button.addEventListener("click", () => {
      activeFilter = button.dataset.newFilter || "all";
      filterButtons.forEach((filterButton) => {
        const isActive = filterButton === button;
        filterButton.classList.toggle("is-active", isActive);
        filterButton.setAttribute("aria-pressed", String(isActive));
      });
      applyProductView();
    });
  });

  sortSelect?.addEventListener("change", applyProductView);
  applyProductView();
}

function setupCollectionSealPage() {
  const shell = document.querySelector(".new-arrivals-page");
  const heroTitle = document.getElementById("bags-title");
  const heroCopy = shell?.querySelector(".new-hero-copy > span");
  const catalogTitle = document.getElementById("bags-products-title");
  const catalogIntro = shell?.querySelector(".new-catalog-head > p");
  const subnav = shell?.querySelector(".collection-subnav");
  const grid = document.querySelector("[data-new-grid]");
  if (!shell || !heroTitle || !catalogTitle || !grid) return;

  const params = new URLSearchParams(window.location.search);
  const collection = params.get("collection") || "bags";

  const presets = {
    bags: {
      title: "Bags",
      intro: "Comfort, style, and everyday practicality.",
      catalog: "All handbags",
      blurb: "Sample bag styles for the Algeria market — canvas bucket, printed tote, geometric top-handle, and everyday carry shapes.",
      active: "bags",
    },
    "clutches-pouches": {
      title: "Clutches & Pouches",
      intro: "Compact clutches, wristlets, and pouches selected for evening and everyday carry.",
      catalog: "Clutches & Pouches",
      blurb: "Embossed compacts and embroidery wallets sized for hand-carry and evening edits.",
      active: "clutches-pouches",
      products: [
        ["Chrisbella embossed compact wallet 01", "3990", "../assets/images/cb-pattern-import/bagco-small-wallet-pu-leather-embossed-compact-sn01.webp", "Rouge"],
        ["Chrisbella embossed compact wallet 02", "3990", "../assets/images/cb-pattern-import/bagco-small-wallet-pu-leather-embossed-compact-sn02.webp", "Vert"],
        ["Chrisbella embossed compact wallet 03", "3990", "../assets/images/cb-pattern-import/bagco-small-wallet-pu-leather-embossed-compact-sn03.webp", "Bronze"],
        ["Chrisbella embossed compact wallet 04", "3990", "../assets/images/cb-pattern-import/bagco-small-wallet-pu-leather-embossed-compact-sn04.webp", "Rose"],
        ["Chrisbella embossed compact wallet 05", "3990", "../assets/images/cb-pattern-import/bagco-small-wallet-pu-leather-embossed-compact-sn05.webp", "Noir"],
        ["Chrisbella embroidery small wallet 1", "3990", "../assets/images/cb-pattern-import/chrisbella-embroidery-jacquard-leather-small-wallet-sn1.webp", "Vert"],
        ["Chrisbella embroidery small wallet 2", "3990", "../assets/images/cb-pattern-import/chrisbella-embroidery-jacquard-leather-small-wallet-sn2.webp", "Bronze"],
        ["Chrisbella embroidery small wallet 3", "3990", "../assets/images/cb-pattern-import/chrisbella-embroidery-jacquard-leather-small-wallet-sn3.webp", "Rose"],
        ["Chrisbella embroidery small wallet 4", "3990", "../assets/images/cb-pattern-import/chrisbella-embroidery-jacquard-leather-small-wallet-sn4.webp", "Noir"],
        ["Chrisbella embroidery medium wallet 1", "4990", "../assets/images/cb-pattern-import/chrisbella-embroidery-jacquard-leather-medium-wallet-sn1.webp", "Rose"],
        ["Chrisbella embroidery medium wallet 2", "4990", "../assets/images/cb-pattern-import/chrisbella-embroidery-jacquard-leather-medium-wallet-sn2.webp", "Noir"],
        ["Chrisbella embroidery medium wallet 3", "4990", "../assets/images/cb-pattern-import/chrisbella-embroidery-jacquard-leather-medium-wallet-sn3.webp", "Beige"],
      ],
    },
  };

  const preset = presets[collection] || presets.bags;
  document.title = `${preset.catalog} | Chrisbella Algeria Preview`;
  heroTitle.textContent = preset.title;
  if (heroCopy) heroCopy.textContent = preset.intro;
  catalogTitle.textContent = preset.catalog;
  if (catalogIntro) catalogIntro.textContent = preset.blurb;

  subnav?.querySelectorAll("a").forEach((link) => {
    const href = link.getAttribute("href") || "";
    const isActive = href.includes(`collection=${preset.active}`);
    link.classList.toggle("is-active", isActive);
  });

  if (preset.products) {
    grid.innerHTML = preset.products
      .map(
        ([name, price, image, color]) => `
      <article class="new-product-card" data-new-product data-category="clutch" data-price="${price}" data-name="${name}">
        <a class="new-product-image" href="/collections/clutches-pouches">
          <span class="new-badge">New</span>
          <img src="${image}" alt="${name}" />
        </a>
        <div class="new-product-info">
          <a href="/collections/clutches-pouches">${name}</a>
          <span>${new Intl.NumberFormat(document.documentElement.lang || "en", { maximumFractionDigits: 2 }).format(Number(price) / 100)} DA</span>
          <div class="new-swatches" aria-label="1 colour"><i style="--swatch:#40352d"></i></div>
        </div>
      </article>`,
      )
      .join("");
  }
}

function buildWhatsAppUrl(phone, message) {
  const digits = String(phone || "").replace(/\D/g, "");
  if (!digits) return "";
  const text = String(message || "").trim();
  const base = `https://wa.me/${digits}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}

async function setupContactInquiryContext() {
  const form = document.getElementById("ChrisbellaContactForm");
  if (!form) return;

  const params = new URLSearchParams(window.location.search);
  if (!["product", "shoe"].includes(params.get("source"))) return;

  const productHandle = String(params.get("product") || "").trim().toLowerCase();
  if (!/^[a-z0-9][a-z0-9-]{0,254}$/.test(productHandle)) return;

  const inquiryType = form.querySelector("[data-contact-inquiry-type]");
  const productHandleInput = form.querySelector("[data-contact-product-handle]");
  const productTitleInput = form.querySelector("[data-contact-product-title]");
  const productOptionInput = form.querySelector("[data-contact-product-option]");
  const productUrlInput = form.querySelector("[data-contact-product-url]");
  const productContext = form.querySelector("[data-contact-product-context]");
  const productLabel = form.querySelector("[data-contact-product-label]");
  const topic = form.querySelector("[data-contact-topic]");
  const message = form.querySelector("[data-contact-message]");

  const localizedProductPath = window.location.pathname.replace(
    /pages\/contact(?:\.html)?\/?$/,
    `products/${encodeURIComponent(productHandle)}`,
  );
  const productPath = localizedProductPath === window.location.pathname
    ? `/products/${encodeURIComponent(productHandle)}`
    : localizedProductPath;

  let productTitle = String(params.get("title") || "").trim();
  let productOption = String(params.get("option") || "").trim();
  const variantId = String(params.get("variant") || "").replace(/\D/g, "");
  const productUrl = new URL(productPath, window.location.origin).href;

  if (!productTitle) {
    try {
      const response = await fetch(`${productPath.replace(/\/$/, "")}.js`, {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
      if (response.ok) {
        const product = await response.json();
        productTitle = String(product?.title || "").trim();
        if (!productOption && variantId && Array.isArray(product?.variants)) {
          const variant = product.variants.find((item) => String(item.id) === variantId);
          productOption = String(variant?.public_title || variant?.title || "").trim();
        }
      }
    } catch {
      // Keep the validated handle fallback when product JSON is temporarily unavailable.
    }
  }

  const productDisplay = productTitle || productHandle.replace(/-/g, " ");
  if (inquiryType) inquiryType.value = "Product question";
  if (productHandleInput) {
    productHandleInput.disabled = false;
    productHandleInput.value = productHandle;
  }
  if (productTitleInput) {
    productTitleInput.disabled = false;
    productTitleInput.value = productDisplay;
  }
  if (productOptionInput && productOption) {
    productOptionInput.disabled = false;
    productOptionInput.value = productOption;
  }
  if (productUrlInput) {
    productUrlInput.disabled = false;
    productUrlInput.value = productUrl;
  }
  if (productLabel) {
    productLabel.textContent = productOption ? `${productDisplay} — ${productOption}` : productDisplay;
  }
  if (productContext) productContext.hidden = false;
  if (topic) topic.value = "Product question";
  if (message && !message.value.trim()) {
    const optionLine = productOption ? `\nOption: ${productOption}` : "";
    message.value = `Product: ${productDisplay}${optionLine}\nProduct URL: ${productUrl}\n\n`;
  }
}

function setupBusinessInquirySource() {
  const field = document.querySelector("[data-business-inquiry-source]");
  if (!field) return;
  const source = new URLSearchParams(window.location.search).get("source");
  if (source) field.value = source.slice(0, 120);
}

function setupContactAutoReply() {
  const form = document.getElementById("ChrisbellaContactForm");
  const endpoint = String(window.CB_CONTACT_CONFIG?.endpoint || "").trim().replace(/\/$/, "");
  if (!form || !endpoint) return;

  const status = form.querySelector("[data-contact-form-status]");
  const submitButton = form.querySelector('[type="submit"]');
  const successMessage = String(window.CB_CONTACT_CONFIG?.successMessage || "").trim();
  const errorMessage = String(window.CB_CONTACT_CONFIG?.errorMessage || "").trim();

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (!form.reportValidity()) return;

    const formData = new FormData(form);
    const payload = {
      name: String(formData.get("contact[name]") || "").trim(),
      email: String(formData.get("contact[email]") || "").trim(),
      phone: String(formData.get("contact[phone]") || "").trim(),
      topic: String(formData.get("contact[Topic]") || "").trim(),
      body: String(formData.get("contact[body]") || "").trim(),
      orderNumber: String(formData.get("contact[Order number]") || "").trim(),
      inquiryType: String(formData.get("contact[Inquiry type]") || "").trim(),
      productTitle: String(formData.get("contact[Product title]") || "").trim(),
      productOption: String(formData.get("contact[Product option]") || "").trim(),
      productUrl: String(formData.get("contact[Product URL]") || "").trim(),
      locale: document.documentElement.lang || "en",
    };

    if (submitButton) submitButton.disabled = true;
    if (status) {
      status.hidden = true;
      status.textContent = "";
    }

    try {
      const response = await fetch(`${endpoint}/contact/submit`, {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || !result.ok) {
        throw new Error(result.message || "contact_submit_failed");
      }
      form.reset();
      if (status) {
        status.hidden = false;
        status.textContent = successMessage || "Thank you. A confirmation has been sent to your email.";
      }
    } catch {
      if (status) {
        status.hidden = false;
        status.textContent = errorMessage || "We could not send your request right now.";
      }
    } finally {
      if (submitButton) submitButton.disabled = false;
    }
  });
}

function setupWhatsAppContact() {
  const panel = document.querySelector(".whatsapp-page");
  if (!panel) return;

  const config = window.CB_WHATSAPP_CONTACT || {
    phone: "213555123456",
    message: "Hello Chrisbella, I would like help with a product or order.",
    auto: new URLSearchParams(window.location.search).get("auto"),
  };
  const url = buildWhatsAppUrl(config.phone, config.message);
  const openButton = panel.querySelector("[data-whatsapp-open]");
  const fallbackLink = panel.querySelector("[data-whatsapp-link]");
  const status = panel.querySelector("[data-whatsapp-status]");
  const fallbackWrap = panel.querySelector("[data-whatsapp-fallback]");

  if (!url) {
    if (status) status.textContent = "WhatsApp contact number is not configured yet.";
    openButton?.setAttribute("disabled", "disabled");
    return;
  }

  const openWhatsApp = () => {
    window.open(url, "_blank", "noopener,noreferrer");
    if (fallbackWrap) fallbackWrap.hidden = false;
    if (status) status.textContent = "WhatsApp should open in a new tab. If not, use the link below.";
  };

  if (fallbackLink) {
    fallbackLink.href = url;
  }
  openButton?.addEventListener("click", openWhatsApp);

  if (config.auto === "1" || config.auto === "true") {
    if (status) status.textContent = "Opening WhatsApp…";
    window.setTimeout(openWhatsApp, 400);
  }
}

setupLanguageMode();
setupPageHeader();
setupCollectionSealPage();
setupNewArrivalsPage();
setupContactInquiryContext();
setupContactAutoReply();
setupBusinessInquirySource();
setupWhatsAppContact();
})();
